export const SAVE_STRATEGY = "SAVE_STRATEGY";
export const LATEST_STRATEGY = "LATEST_STRATEGY";
export const TEMP_ID_STRATEGY = "TEMP_ID_STRATEGY";
export const SAVED_ID_STRATEGY = "SAVED_ID_STRATEGY";
export const REQUEST_STRATEGY = "REQUEST_STRATEGY";
export const REQUEST_LOCK = "REQUEST_LOCK";
export const REQUEST_UNLOCK = "REQUEST_UNLOCK";
